import { render, staticRenderFns } from "./SingleDependent.vue?vue&type=template&id=05a130be&"
import script from "./SingleDependent.vue?vue&type=script&lang=js&"
export * from "./SingleDependent.vue?vue&type=script&lang=js&"
import style0 from "./SingleDependent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports